/** Visual tokens from the approved CyberPay merchant portal reference. */
const colors = {
  brand: { main: "#c6f03a", ink: "#3f5406", soft: "#f3f8e5" },
  surface: { main: "#fafaf7", alternate: "#f5f3ee" },
  background: {
    default: "#f1f1ee",
    paper: "#ffffff",
  },

  text: {
    primary: "#0b0b0c",
    secondary: "#5c5c57",
    main: "#5c5c57",
    focus: "#5c5c57",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#0b0b0c",
    main: "#0b0b0c",
    focus: "#0b0b0c",
  },

  primary: {
    main: "#c6f03a",
    contrastText: "#0b0b0c",
    focus: "#d3f75a",
  },

  secondary: {
    main: "#5c5c57",
    focus: "#454540",
  },

  info: {
    main: "#c6f03a",
    contrastText: "#0b0b0c",
    focus: "#d3f75a",
  },

  success: {
    main: "#3f5406",
    focus: "#526c0b",
  },

  warning: {
    main: "#7a520c",
    focus: "#946516",
  },

  error: {
    main: "#a33124",
    focus: "#86271d",
  },

  light: {
    main: "#eeeee9",
    focus: "#eeeee9",
  },

  dark: {
    main: "#0b0b0c",
    focus: "#0b0b0c",
  },

  grey: {
    100: "#f1f1ee",
    200: "#eeeee9",
    300: "#e4e4de",
    400: "#cacac1",
    500: "#aaa99e",
    600: "#707069",
    700: "#5c5c57",
    800: "#343430",
    900: "#1d1d1b",
  },

  gradients: {
    primary: {
      main: "#c6f03a",
      state: "#c6f03a",
    },

    secondary: {
      main: "#5c5c57",
      state: "#5c5c57",
    },

    info: {
      main: "#c6f03a",
      state: "#c6f03a",
    },

    success: {
      main: "#3f5406",
      state: "#3f5406",
    },

    warning: {
      main: "#7a520c",
      state: "#7a520c",
    },

    error: {
      main: "#a33124",
      state: "#a33124",
    },

    light: {
      main: "#cacac1",
      state: "#eeeee9",
    },

    dark: {
      main: "#0b0b0c",
      state: "#0b0b0c",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  alertColors: {
    primary: {
      main: "#c6f03a",
      state: "#3f5406",
      border: "#dce8bc",
    },

    secondary: {
      main: "#5c5c57",
      state: "#55554e",
      border: "#e4e4de",
    },

    info: {
      main: "#c6f03a",
      state: "#3f5406",
      border: "#dce8bc",
    },

    success: {
      main: "#3f5406",
      state: "#3f5406",
      border: "#dce8bc",
    },

    warning: {
      main: "#7a520c",
      state: "#7a520c",
      border: "#efddb0",
    },

    error: {
      main: "#a33124",
      state: "#a33124",
      border: "#f0cfc9",
    },

    light: {
      main: "#cacac1",
      state: "#eeeee9",
      border: "#f1f1ee",
    },

    dark: {
      main: "#0b0b0c",
      state: "#0b0b0c",
      border: "#cacac1",
    },
  },

  badgeColors: {
    primary: {
      background: "#edf4da",
      text: "#3f5406",
    },

    secondary: {
      background: "#eeeee9",
      text: "#55554e",
    },

    info: {
      background: "#edf4da",
      text: "#3f5406",
    },

    success: {
      background: "#edf4da",
      text: "#3f5406",
    },

    warning: {
      background: "#fff4d5",
      text: "#7a520c",
    },

    error: {
      background: "#fff0ed",
      text: "#a33124",
    },

    light: {
      background: "#ffffff",
      text: "#5c5c57",
    },

    dark: {
      background: "#eeeee9",
      text: "#0b0b0c",
    },
  },

  inputColors: {
    borderColor: { main: "#cacac1", focus: "#3f5406" },
    boxShadow: "#e4efc5",
    error: "#a33124",
    success: "#3f5406",
  },

  sliderColors: {
    thumb: { borderColor: "#d9d9d9" },
  },

  circleSliderColors: {
    background: "#d3d3d3",
  },

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
